export const SET_REMEMBER_ME = "client/login/SET_REMEMBER_ME";

export default function setRememberMe(value) {
  return {
    "payload": value,
    "type": SET_REMEMBER_ME
  };
}
